import { format } from "lib/globalize-util";
import { emailRegExp } from "lib/validators";

export const validationRules = {
    required: ({ fieldName }: { fieldName: string }) => format("Enter {fieldName} to proceed.", { fieldName }),
    maxLength: ({ value }) => ({
        value,
        message: format("Input exceeds the character limit of {value}", { value }),
    }),
    email: ({ value = emailRegExp }: { value?: RegExp } = {}) => ({
        value,
        message: format("Enter a valid email address."),
    }),
    trimAndValidateRequired: ({ fieldName }: { fieldName: string }) => ({
        validate: (value: string) => {
            if (!value.trim()) {
                return format("Enter {fieldName} to proceed.", { fieldName });
            }
            return true;
        },
    }),
};
